//import * as types from "@/store/mutation-types";
//import api from "@/services/api/registration";

const getters = {};

const actions = {};

const mutations = {};

const state = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
